<template>
	<div>
		<ContainerTitle icon="cloud-load" title="Importar Beneficiários"/>
		<div class="restart-container" v-if="showRestartModal">
			<div class="wrap">
				<p>
					O upload do arquivo <span class="hight-light">{{importacao.fileName}}</span> está em andamento. 
					Se o upload estiver ocorrendo em outra janela, aguarde.
				</p>
				<p>
					Caso tenha ocorrido um problema na janela deste upload, você pode cancelá-lo ou 
					continuar a importação submentendo o mesmo arquivo, continuando 
					na linha <span class="hight-light">{{importacao.lastLine}}</span>.
				</p>
				<div class="buttons-box">
					<b-button pill class="btn-base cancelar-importacao optum-bold" @click="$bvModal.show('cancelar-import-beneficiario')">Cancelar</b-button>
					<b-button pill class="btn-base continuar-importacao optum-bold" @click="showRestartModal = false">Continuar Upload</b-button>
				</div>
			</div>
		</div>
		
		<UploadBeneficiarios :importacao="importacao" :continueLostImport="continueLostImport"
		v-else-if="!importacao.status || importacao.status == 'PRE_IMPORTING'" @updateImportacao="updateImportacao" />
		
		<EditarBeneficiarioImportacaoList :importacao="importacao" v-else-if="importacao.status == 'WAINTING_START' && revise"
		@updateImportacao="updateImportacao" @canceled="clear" />
		
		<ImportacaoEmAndamento :importacao="importacao" :finishImportacao="finishImportacao"
		v-else
		@updateImportacao="updateImportacao" />


		<b-modal id="editar-importacao-error" centered hide-header
        header-class="deletar-perfil-sub-header" body-class="deletar-perfil-body" no-close-on-backdrop no-stacking no-close-on-esc>
            <DynamicIcon icon="exclamation" classString="icons-svg"/>
			<p class="text-modal">Encontramos alguns erros no arquivo, deseja realizar a correção?</p>
			<template #modal-footer>
				<div class="corrigir-importacao-button">
					<b-button pill class="btn-base outline-primary-btn mr-4 optum-bold" @click="$bvModal.show('cancelar-import-beneficiario')">Cancelar a validação</b-button>
					<b-button pill class="btn-base primary-btn optum-bold" @click="corrigirImportacao">Corrigir</b-button>
				</div>
            </template>	
        </b-modal>

		<ModalCancelarImportacaoBeneficiario :importacaoId="importacao.id" :status="importacao.status" @canceled="clear" />
		
		<ModalAlert id="modal-response-message-error" @close="finalizarImportacao">
          <DynamicIcon icon="not" :classString="'alert-exclamation'"/>
          {{ responseMessage }}
      </ModalAlert>
	
	</div>
</template>

<script>
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import UploadBeneficiarios from "./components/UploadBeneficiarios"
import EditarBeneficiarioImportacaoList from "./components/EditarBeneficiarioImportacaoList"
import ImportacaoEmAndamento from "./components/ImportacaoEmAndamento"
import ModalCancelarImportacaoBeneficiario from "./components/ModalCancelarImportacaoBeneficiario"
import ModalAlert from "@/components/commons/ModalAlert.vue"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import Validations from "@/util/Validations";
import ContainerTitle from "@/components/commons/ContainerTitle.vue";

let importacaoEmpty = {
	id: null,
	userId: null,
	startPreImportDate: null,
	endPreImportDate: null,
	status: null,
	lastLine: null,
	hasErrorCpfCnpj: false,
	hasErrors: null,
}

export default {
	name: "ImportarBeneficiarios",
	icon : "cloud-load",
	components: {
		UploadBeneficiarios,
		EditarBeneficiarioImportacaoList,
		ImportacaoEmAndamento,
		ModalCancelarImportacaoBeneficiario,
		DynamicIcon,
		ModalAlert,
		ContainerTitle
	},
	data() {
		return {
			importacao: {...importacaoEmpty},
			showRestartModal: false,
			continueLostImport: false,
			revise: null,
			responseMessage: null,
			finishImportacao: false,
		}
	},
    methods: {
		updateImportacao(importacao) {
			if (!importacao) {
				this.clear()
				return
			}

			this.importacao = importacao
			this.validarImportacao()
		},
		clear() {
			this.importacao = {...importacaoEmpty}
			this.showRestartModal = false
			this.continueLostImport = false
			this.finishImportacao = true
		},
		loadImportacaoAtiva()
		{
			BeneficiarioImportacaoResource.getImportacaoAtiva({showLoader: true})
			.then((importacao) => {
				if (!importacao || !importacao.id) {
					return
				}

				this.importacao = {
					id: importacao.id,
					userId: importacao.userId,
					startPreImportDate: importacao.startPreImportDate,
					endPreImportDate: importacao.endPreImportDate,
					status: importacao.status,
					fileName: importacao.fileName,
					lastLine: importacao.lastLine,
					hasErrorCpfCnpj: importacao.hasErrorCpfCnpj,
					hasErrors: importacao.hasErrors
				}

				//if on created already exists importacao
				this.showRestartModal = "PRE_IMPORTING" == importacao.status
				this.continueLostImport = true
				this.validarImportacao()
			})
		},
		cancelarImportacao()
		{
			this.$bvModal.hide('editar-importacao-error')
			this.$bvModal.show('cancelar-import-beneficiario')
		},
		corrigirImportacao()
		{
			this.$bvModal.hide('editar-importacao-error')
			this.revise=true
		},
		iniciarImportacao()
		{
			BeneficiarioImportacaoResource.iniciarImportacao(this.importacao.id, {showLoader: true})
			.then(()=> {
				setTimeout(() => this.loadImportacaoAtiva(), 1000)
			})
			.catch(err => {
				this.showModalError(err)
			})
		},
		validarImportacao()
		{
			if(this.importacao.status == 'WAINTING_START') {
				BeneficiarioImportacaoResource.checkImportacao(this.importacao.id, {showLoader: false})
				.then(response => {
					let result = typeof response === 'object' ? response.data : response
					if ( result ) {
						this.iniciarImportacao()
					} 
					else {
						this.$bvModal.show('editar-importacao-error')
					}
				})
				.catch(err => {
					this.showModalError(err) 
				}) 
			}
		},
		finalizarImportacao() {
			BeneficiarioImportacaoResource
			.deletarImportacao(this.importacao.id, {showLoader: true})
            .then(() => this.$router.go(0))
		},
		showModalError(err) {
			this.responseMessage = Validations.getMessageError(err.errors[0])
			this.$bvModal.show('modal-response-message-error')
		}
    },
	created() {
		this.loadImportacaoAtiva()
	}
}
</script>

<style scoped>
.restart-container {
	background-color: white;
    padding: 100px;
    margin-top: 20px;
}

.restart-container .wrap {
	display: inline-block;
}

.restart-container p {
	text-align: left;
}

.restart-container .hight-light {
	font-weight: bold;
}

.restart-container .buttons-box {
	margin-top: 60px;
}

.restart-container .buttons-box button {
	font-weight: bold !important;
	margin-left: 10px;
}

.restart-container .buttons-box button.continuar-importacao {
	background-color: #FF612B;
}

.modal-title-flex-bene  {
    width: 100% !important;
    display: flex;
    justify-content: space-between ;
    align-items: center;
}
.modal-title-content-bene  {
    display: flex;
    justify-content: flex-start ;
    align-items: center;
    gap: 17px;
}

.modal-title-text-bene {
	font-family: optum-sans-bold;
    font-weight: 700;
    font-size: 24px;
	line-height: 24px;
    color: rgb(0, 38, 119);
    text-align: left;
}

.icon-tittle-bene{
	height: 45px;
	margin-bottom: 0px !important;
}

.modal-header-p {
    margin: 0px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    font-size: 16px;
    color: rgb(90, 90, 90);
}

.select-tipo-importacao {
    text-align: left;
    width: 100%;
    border: 2px solid rgb(209, 209, 209);
    border-radius: 16px;
    padding: 8px;
    background-color: rgb(255, 255, 255);
    text-decoration: none;
    margin-top: 16px;
    font-weight: 400;
}

.select-tipo-importacao h5 {
	color:rgb(0, 38, 119);
}

.select-tipo-importacao:hover {
    border-color: rgb(0, 38, 119);
    background-color: rgb(217, 246, 250);;
}

.text-modal {
font-family: optum-sans;
font-size: 16px;
font-weight: 400;
line-height: 24px;
letter-spacing: 0em;
text-align: center;
}
.corrigir-importacao-button {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>